import { faClock, faStar } from "@fortawesome/free-regular-svg-icons";
import { faQuestion, faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { styled } from "@mui/material/styles";
import { DocumentStatusRef } from "../../models/documents/document-statuses/document-status-ref";
import { DOCUMENTS_STATUS_TYPES } from "../../utils/constants/constants";

const CustomFontAwesomeIcon = styled(FontAwesomeIcon, {
  shouldForwardProp: (prop) => prop !== "customColor",
})<{ customColor: "secondary" | "primary" | "success" | "error" }>(
  {
    fontSize: "25px",
  },
  ({ theme, customColor }) => ({
    ...(customColor && {
      color: theme.palette[customColor].main,
    }),
  })
);

export const getDocumentStatusIcon = (documentStatus: DocumentStatusRef) => {
  switch (documentStatus.id) {
    case DOCUMENTS_STATUS_TYPES.PENDING.id:
      return (
        <CustomFontAwesomeIcon
          icon={faClock}
          title={documentStatus.name}
          customColor="error"
        />
      );

    case DOCUMENTS_STATUS_TYPES.CLARIFICATION_REQUESTED.id:
      return (
        <CustomFontAwesomeIcon
          icon={faQuestion}
          title={documentStatus.name}
          customColor="secondary"
        />
      );

    case DOCUMENTS_STATUS_TYPES.VERIFIED.id:
      return (
        <CustomFontAwesomeIcon
          icon={faCheck}
          title={documentStatus.name}
          customColor="success"
        />
      );

    case DOCUMENTS_STATUS_TYPES.PROCESSED.id:
      return (
        <CustomFontAwesomeIcon
          icon={faStar}
          title={documentStatus.name}
          customColor="primary"
        />
      );

    default:
      return (
        <CustomFontAwesomeIcon
          icon={faClock}
          title={documentStatus.name}
          customColor="error"
        />
      );
  }
};
